import { getToken } from 'firebase/app-check';
import { appCheck } from '../../firebase';


export function useAddMessage() {
  
  const addMessage = async (conversationId: string, messageId: string, sender: string, content: string) => {

    try {

      const { token } = await getToken(appCheck);
      const authToken = localStorage.getItem('authToken')

      const res = await fetch('/addMessage', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Firebase-Appcheck': token,
          Authorization: `Bearer ${authToken}`
        },

        body: JSON.stringify({ conversationId, messageId, sender, content }),

      })

      if (!res.ok) throw new Error(await res.text())

      const data = await res.json()
      return data

    } catch (err) {
      console.error('Error adding message', err)
    }

  }

  return { addMessage }
  
}
